export default "__VITE_ASSET__RTH7iGTS__"